import React from 'react';
import './UpdateNotification.css';

interface UpdateNotificationProps {
  onUpdate: () => void;
  onDismiss: () => void;
}

const UpdateNotification: React.FC<UpdateNotificationProps> = ({ onUpdate, onDismiss }) => {
  return (
    <div className="update-notification">
      <div className="update-notification-content">
        <div className="update-notification-icon">🔄</div>
        <div className="update-notification-text">
          <strong>Neue Version verfügbar!</strong>
          <p>Eine neue Version der App ist verfügbar. Bitte aktualisieren Sie, um die neueste Version zu verwenden.</p>
        </div>
        <div className="update-notification-actions">
          <button className="btn-update" onClick={onUpdate}>
            Jetzt aktualisieren
          </button>
          <button className="btn-dismiss" onClick={onDismiss}>
            Später
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotification;
